import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EVENT_SCHEMA, EventTrackerInternalService } from '@app/services/event-tracker-2.service';
import { EventTrackerService, QiraEventHumanReadable } from '@app/services/event-tracker.service';
import { TabService } from '@app/services/tab.service';
import { ChatTab } from '@app/services/types';
import { ModalService } from '@app/components/modal/modal.service';

@Component({
  selector: 'app-close-tab-button',
  imports: [CommonModule],
  templateUrl: './close-tab-button.component.html',
  standalone: true,
  styleUrl: './close-tab-button.component.scss',
})
export class CloseTabButtonComponent {
  @Input({ required: true }) tab?: ChatTab;
  @Input() iconClass?: string;
  @Output() onClick = new EventEmitter<Event>();
  @Output() onClose = new EventEmitter();

  tabService = inject(TabService);
  router = inject(Router);

  eventTracker = inject(EventTrackerService);
  eventTrackerInternal = inject(EventTrackerInternalService);

  modalService = inject(ModalService);

  closeTab(event: Event, tabId: string | undefined): void {
    if (!tabId) return;

    this.onClick.emit(event);
    event.stopPropagation();

    this.modalService
      .confirm(
        'chat.closeThread.heading', 
        'chat.closeThread.text', 
        'chat.closeThread.button', 
        'chat.closeThread.cancelButton'
      )
      .then(async (confirmed) => {
        if (confirmed) {
          await this.tabService.deleteTab(tabId);

          this.onClose.emit();

          // deprecated event tracking
          await this.eventTracker.logEvent(QiraEventHumanReadable.USER_CLICK_CLOSE_THREAD, {
            thread_id: tabId,
          });

          await this.eventTrackerInternal.trackEvent(EVENT_SCHEMA.CORE_PRODUCT.UI.THREAD_CLOSED, {
            thread_id: tabId,
          });
        }
      });
  }
}
